import * as advancedSearch from './advancedSearch';
import * as allShares from './allShares';
import * as c2cConnections from './c2cConnections';
import * as c2cConnectionsRSC from './c2cConnectionsRSC';
import * as project from './project';
import * as settings from './settings';
import * as shareBuilder from './shareBuilder';
import * as shareReviewFinder from './shareReviewFinder';
import * as shareReviewReel from './shareReviewReel';
import * as shareReviewViewer from './shareReviewViewer';
import * as staticProjectNavigation from './staticProjectNavigation';
import * as trash from './trash';
import * as uploaderApp from './uploaderApp';
import * as uploadLinks from './uploadLinks';
import * as viewer from './viewer';
import * as workspaces from './workspaces';

export const layouts = {
  allShares,
  collection: project,
  project,
  c2cConnections,
  c2cConnectionsRSC,
  advancedSearch,
  settings,
  shareBuilder,
  viewer,
  workspaces,
  shareReviewViewer,
  shareReviewFinder,
  shareReviewReel,
  staticProjectNavigation,
  trash,
  uploaderApp,
  uploadLinks,
} as const;
